import { connect } from "react-redux";
import get from "lodash/get";
import { setFullScreen as onSetFullScreen } from "../../actions/intelligenceControlAction";

import {} from "../../actions/signalRActions";

const mapStateToProps = (state) => ({
  fullScreen: get(state, ["intelligenceControl", "fullScreen"], false),
});

const mapDispatchToProps = {
  onSetFullScreen,
};

const withIntelligenceControl = (Component) => connect(mapStateToProps, mapDispatchToProps)(Component);

export { withIntelligenceControl };
